import React from 'react'
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css'
import 'swiper/swiper.min.css'
import Style from './SliderSite.module.css'

// import Swiper core and required modules
import SwiperCore, {
  EffectCoverflow,Pagination,Navigation
} from 'swiper';
import {  Card } from 'react-bootstrap';
import Button from '../Button/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faVideo } from '@fortawesome/free-solid-svg-icons';
import { useEffect } from 'react';
import { useState } from 'react';
import { getCourseListApi } from '../../Api/ClientServices';
import ReactLoading from 'react-loading';
import { Link } from 'react-router-dom';
// install Swiper modules
SwiperCore.use([EffectCoverflow,Pagination,Navigation]);




const SliderSite = () => {
  const[courseList,setCourseList]=useState()
  const[pageWidth,setPageWidth]=useState()
  useEffect(()=>{
    setPageWidth(window.innerWidth)
  },[])

  useEffect(()=>{
    getCourseList()
  },[])
  const getCourseList=async()=>{
    const data=await getCourseListApi()
    setCourseList(data)
  }
  let loadingHandler=null
  if(courseList===undefined){
    loadingHandler=<div className='w-100 d-flex align-items-center justify-content-center'>
      <ReactLoading type={'cylon'} color={'#096CCC'} />
    </div>
     
  }
  else{
    loadingHandler=<Swiper 
    // loop={true}  
    grabCursor={true} 
    // cssMode={true}
    // mousewheel={true} keyboard={true}
    centeredSlides={true} 
    slidesPerView={pageWidth>999?3:1} 
    navigation={true}
    spaceBetween={30}
    coverflowEffect={{"slideShadows": false}} pagination={true} className={Style.mySwiper}>
                    {
                      courseList.courses.map(item=>{
                        return(
                          <SwiperSlide key={item.id} className={Style.swiper_slide}>
                          <Card style={{ width: '19rem' }} className={Style.CardHolder}>
                            <Card.Img variant="top" src={`https://cdn.electronicsteps.ir/course/cover/${item.cover}.jpg`}/>
                            <Card.Body className={Style.CardBodyHolder}>
                              <Card.Title style={{fontSize:'0.8rem'}} className={Style.TitleCardHolder}><FontAwesomeIcon icon={faVideo}/> {item.name}</Card.Title>
                              {/* <h3>{item.name}</h3> */}
                              <Link to={`/course/${item.id}`}><Button Value={'اطلاعات بیشتر'} ClassBtn={'confirmBtn'}/></Link>
                            </Card.Body>
                          </Card>
                          </SwiperSlide>
                        )
                      })
                    }
                    
                </Swiper>
  }

    return (
      <div className={Style.SliderHolder}>
        {
          loadingHandler
        }
      </div>
    )
}

export default SliderSite
